import Vue from 'vue';

import MovingImage from '@components/ui/movingimage.vue';

let PageComponent = {
  name: 'aboutUs',
  data: function() {
    return {
      template: '<p>default temp</p>',
      items: {},
    };
  },
  components: {
    't-image': MovingImage,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let about = document.querySelector('#about');
    if (about) {
      about.remove();
    }
    let url = '/api/templates/info/about';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/info/about/index.js